import React, { DetailedReactHTMLElement, useRef } from 'react';
import {
  DropdownChildrenProps,
  DropdownProps,
  DropdownSelectMenuOption,
} from '~web/view/components/ui/form/dropdown-select-menu.component';

export const DropdownSelectMenuMobile: React.FunctionComponent<Omit<
  DropdownProps,
  'yOffset' | 'xOffset' | 'rightAligned' | 'topAligned' | 'isOpen'
>> = ({
  currentValue,
  options,
  handleItemSelected,
  optionalDescription,
  onDropdownOpen,
  children,
}) => {
  const buttonRef = useRef<HTMLDivElement>(null);

  const selectOnClick = (event: React.MouseEvent): void => {
    event.stopPropagation();
    if (onDropdownOpen) {
      onDropdownOpen(true);
    }
  };

  const onItemSelected = (value: string): void => {
    if (handleItemSelected) {
      handleItemSelected(value);
    }
  };

  return (
    <>
      <div ref={buttonRef}>
        {React.cloneElement<DropdownChildrenProps, HTMLElement>(
          children as DetailedReactHTMLElement<DropdownChildrenProps, HTMLElement>,
          {
            tabIndex: -1,
          },
        )}
      </div>
      <select
        value={currentValue || '_hidden'}
        onChange={(event: React.ChangeEvent<HTMLSelectElement>): void => {
          onItemSelected(event.currentTarget.value);
        }}
        onClick={selectOnClick}
      >
        {optionalDescription && <optgroup label={optionalDescription} />}
        <option key={'_hidden'} value={'_hidden'} hidden />
        {options.map((option: DropdownSelectMenuOption) => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </>
  );
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/form/dropdown-select-menu-mobile.component.tsx